/**
 * Envío AP-12 · paginación de la Galería: tamaños de página y la ventana de
 * números que se muestra («1 … 4 5 6 … 20»).
 */
export const PAGE_SIZES = [60, 120, 200];
export const DEFAULT_PAGE_SIZE = 60;

export const pageCount = (total, size) => Math.max(1, Math.ceil((Number(total) || 0) / (size || DEFAULT_PAGE_SIZE)));

/** Números a mostrar; `null` marca un salto («…»). */
export function pageWindow(page, pages, around = 1) {
  if (pages <= 7) return Array.from({ length: pages }, (_, i) => i + 1);
  const out = [1];
  const from = Math.max(2, page - around);
  const to = Math.min(pages - 1, page + around);
  if (from > 2) out.push(null);
  for (let p = from; p <= to; p += 1) out.push(p);
  if (to < pages - 1) out.push(null);
  out.push(pages);
  return out;
}

/** «61–120 de 1.170» */
export function rangeLabel(page, size, total) {
  if (!total) return '0 de 0';
  const a = (page - 1) * size + 1;
  const b = Math.min(page * size, total);
  const f = (n) => n.toLocaleString('es-AR');
  return `${f(a)}–${f(b)} de ${f(total)}`;
}
